"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareStakingContractsInitialValues = exports.stakingContractFilter = void 0;
const types_1 = require("../../../../../types");
const stakingContractFilter = (service) => ({ title, description, imageUrl, contractStatus, merchantId }) => ({
    title,
    description,
    imageUrl,
    contractStatus,
    merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
});
exports.stakingContractFilter = stakingContractFilter;
const prepareStakingContractsInitialValues = (service) => ({ id, title, description, imageUrl, contractStatus, address, merchantId }) => {
    return {
        id,
        title,
        description,
        address,
        contractStatus,
        imageUrl,
        merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
    };
};
exports.prepareStakingContractsInitialValues = prepareStakingContractsInitialValues;
//# sourceMappingURL=schemas.js.map